import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("获奖排名")
const _hoisted_6 = {
  key: 0,
  class: "text-center py-3 text-danger"
}
const _hoisted_7 = {
  key: 1,
  class: "px-4 py-2"
}
const _hoisted_8 = { class: "mb-2 text-muted" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("获奖")
const _hoisted_10 = {
  key: 2,
  class: "text-center py-3"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "加载排名中...", -1)
const _hoisted_12 = { class: "text-muted small" }
const _hoisted_13 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-muted" }, "加载中...", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  class: "mb-3 text-muted",
  style: {"font-size":"13px","line-height":"1.8"}
}
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = {
  key: 2,
  class: "text-center py-4 text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "box_info_id",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.formData.box_info_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.box_info_id) = $event)),
                placeholder: "选择套系",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boxInfoOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "mobile",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.mobile,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                placeholder: "用户手机号"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "from",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.from,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.from) = $event)),
                type: "datetime",
                placeholder: "开始时间",
                format: "YYYY-MM-DD HH:mm:ss",
                "value-format": "YYYY-MM-DD HH:mm:ss"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "to",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.formData.to,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.to) = $event)),
                type: "datetime",
                placeholder: "结束时间",
                format: "YYYY-MM-DD HH:mm:ss",
                "value-format": "YYYY-MM-DD HH:mm:ss"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onReset
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_vxe_button, {
                type: "button",
                status: "warning",
                onClick: _ctx.onWinnerRanking
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      ref: "tableRef",
      data: _ctx.tableData,
      "row-config": { isHover: true },
      "expand-config": { lazy: true, loadMethod: _ctx.loadRanking }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          type: "expand",
          width: "60"
        }, {
          content: _withCtx(({ row }) => [
            (_ctx.expandData[row.id]?.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.expandData[row.id].error), 1))
              : (_ctx.expandData[row.id]?.ranking)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, " 箱子: " + _toDisplayString(_ctx.expandData[row.id].ranking.box_name) + " | 区间: " + _toDisplayString(_ctx.expandData[row.id].ranking.range[0]) + " ~ " + _toDisplayString(_ctx.expandData[row.id].ranking.range[1]) + " | 总抽数: " + _toDisplayString(_ctx.expandData[row.id].ranking.total_draws), 1),
                    _createVNode(_component_vxe_table, {
                      data: _ctx.expandData[row.id].ranking.rankings,
                      "row-config": { isHover: true },
                      size: "mini",
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_vxe_column, {
                          field: "rank",
                          title: "排名",
                          width: "60"
                        }, {
                          default: _withCtx(({ row: r }) => [
                            _createElementVNode("span", {
                              class: _normalizeClass({ 'fw-bold text-warning': r.rank <= 3 })
                            }, _toDisplayString(r.rank), 3)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_vxe_column, {
                          field: "user_id",
                          title: "用户ID",
                          width: "80"
                        }),
                        _createVNode(_component_vxe_column, {
                          field: "mobile",
                          title: "手机号",
                          width: "130"
                        }),
                        _createVNode(_component_vxe_column, {
                          field: "nickname",
                          title: "昵称",
                          width: "120"
                        }),
                        _createVNode(_component_vxe_column, {
                          field: "draw_count",
                          title: "抽奖次数",
                          width: "100"
                        }, {
                          default: _withCtx(({ row: r }) => [
                            _createElementVNode("span", {
                              class: _normalizeClass({ 'fw-bold': r.is_winner })
                            }, _toDisplayString(r.draw_count), 3),
                            (r.is_winner)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: "danger",
                                  size: "small",
                                  class: "ms-1"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["data"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_el_icon, { class: "is-loading" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Loading)
                      ]),
                      _: 1
                    }),
                    _hoisted_11
                  ]))
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID",
          width: "80"
        }),
        _createVNode(_component_vxe_column, {
          field: "box_info_name",
          title: "套系",
          width: "150"
        }),
        _createVNode(_component_vxe_column, {
          title: "获奖用户",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.user_nickname || '-'), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(row.user_mobile || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "product_name",
          title: "奖品",
          width: "200"
        }),
        _createVNode(_component_vxe_column, {
          title: "奖品价值",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.product_recycle_price ? Number(row.product_recycle_price).toFixed(2) + '元' : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          title: "区间",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.range_from || '-') + " ~ " + _toDisplayString(row.range_to || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "获奖时间",
          width: "160"
        })
      ]),
      _: 1
    }, 8, ["data", "expand-config"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.winnerDialogVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.winnerDialogVisible) = $event)),
      title: "冲冲赏获奖排名",
      width: "600px"
    }, {
      default: _withCtx(() => [
        (_ctx.winnerLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_el_icon, {
                class: "is-loading",
                size: 24
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Loading)
                ]),
                _: 1
              }),
              _hoisted_14
            ]))
          : (_ctx.winnerData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", null, "时间: " + _toDisplayString(_ctx.winnerData.from) + " ~ " + _toDisplayString(_ctx.winnerData.to), 1),
                  _createElementVNode("div", null, "获奖人数: " + _toDisplayString(_ctx.winnerData.total_winners) + " | 总获奖次数: " + _toDisplayString(_ctx.winnerData.total_wins), 1)
                ]),
                _createVNode(_component_vxe_table, {
                  data: _ctx.winnerData.rankings,
                  "row-config": { isHover: true },
                  size: "small",
                  border: "",
                  "max-height": "400"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vxe_column, {
                      field: "rank",
                      title: "排名",
                      width: "60"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'fw-bold text-warning': row.rank <= 3 })
                        }, _toDisplayString(row.rank), 3)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "user_id",
                      title: "用户ID",
                      width: "80"
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "mobile",
                      title: "手机号",
                      width: "140"
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "nickname",
                      title: "昵称",
                      width: "140"
                    }),
                    _createVNode(_component_vxe_column, {
                      field: "win_count",
                      title: "获奖次数",
                      width: "100"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(row.win_count), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, "暂无数据"))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}